import { createAction } from 'redux-actions-helpers'
import { AchievementType } from './types'

export const fetchAchievement = createAction(
  '@@admin-achievement/FETCH_ACHIEVEMENT',
  (id: string): any => ({ id })
)

export const fetchAchievementSuccess = createAction(
  '@@admin-achievement/FETCH_ACHIEVEMENT_SUCCESS',
  (result: AchievementType): any => ({ result })
)

export const fetchAchievementFailure = createAction(
  '@@admin-achievement/FETCH_ACHIEVEMENT_FAILURE',
  (error: string): any => ({ error })
)

export const editAchievement = createAction(
  '@@admin-achievement/EDIT_ACHIEVEMENT',
  (
    id: string,
    status: string,
    caption: string,
    requirements: string,
    description: string,
    shareDescription: string,
    image?: File
  ): any => ({
    id,
    status,
    caption,
    requirements,
    description,
    shareDescription,
    image,
  })
)

export const editAchievementSuccess = createAction(
  '@@admin-achievement/EDIT_ACHIEVEMENT_SUCCESS'
)

export const editAchievementFailure = createAction(
  '@@admin-achievement/EDIT_ACHIEVEMENT_FAILURE',
  (error: string): any => ({ error })
)

export const fetchUsersCount = createAction(
  '@@admin-achievement/FETCH_USERS_COUNT'
)

export const fetchUsersCountSuccess = createAction(
  '@@admin-achievement/FETCH_USERS_COUNT_SUCCESS',
  (count: number): any => ({ count })
)

export const fetchUsersCountFailure = createAction(
  '@@admin-achievement/FETCH_USERS_COUNT_FAILURE',
  (error: string): any => ({ error })
)

export const destroy = createAction('@@admin-achievement/DESTROY')
